import { render, staticRenderFns } from "./InvitationCodeList.vue?vue&type=template&id=3688fb67&scoped=true&"
import script from "./InvitationCodeList.vue?vue&type=script&lang=js&"
export * from "./InvitationCodeList.vue?vue&type=script&lang=js&"
import style0 from "./InvitationCodeList.vue?vue&type=style&index=0&id=3688fb67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3688fb67",
  null
  
)

export default component.exports